import { map, update } from 'lodash/fp';
import { nanoid } from 'nanoid';

const insertRandomKeys = map(update('key', nanoid));

export { insertRandomKeys };
